exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".disable-scroll-chaining{-ms-scroll-chaining:none;overscroll-behavior:contain}.toasted-container{z-index:10}", ""]);
